import React from 'react';

import BenchlingQuery from 'graphql-client/BenchlingQuery';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {CenteredSpinner} from 'ui-library/Spinner';

import {
  StorableRelevantItemsQuery,
  StorableRelevantItemsQueryVariables,
} from './__generated/StorableRelevantItemsQuery';
import StorablePresentationalRelevantItemsSection from './StorablePresentationalRelevantItemsSection';
import {STORABLE_RELEVANT_ITEMS_QUERY} from './StorableRelevantItemsGraphQL';

interface StorableRelevantItemsSectionProps {
  storableId: string;
}

export default function StorableRelevantItemsSection({
  storableId,
}: StorableRelevantItemsSectionProps): JSX.Element {
  return (
    <BenchlingQuery<StorableRelevantItemsQuery, StorableRelevantItemsQueryVariables>
      query={STORABLE_RELEVANT_ITEMS_QUERY}
      variables={{storableId}}
      renderLoading={() => <CenteredSpinner />}
    >
      {(data) => {
        if (data == null || isInaccessible(data.storable)) {
          return 'No access'; // Shouldn't get here because the storable page is already guarded by permissions, but just in case :)
        }
        return (
          <StorablePresentationalRelevantItemsSection
            relevantItemsGraphQL={data.storable.relevantItems}
            storableId={storableId}
          />
        );
      }}
    </BenchlingQuery>
  );
}
